// import hooks
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import ChangeBtn from "./ChangeBtn";
import SaveBtn from "./SaveBtn";

// import assets

// import data

const Name = ({ name, onHandleChange }) => {
    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();
    // const [name, setName] = useState(uname);

    const [showEdit, setShowEdit] = useState(false);

    const handleChange = (e) => {
        // e=>setName(e.target.value);
        onHandleChange(e.target.value);
    };

    return (
        <div className="account-name-container account-personal-item">
            {!showEdit ? (
                <div className="name-preview item-preview flex-between-row">
                    <div className="account-personal-txt">
                        <p className="ocean-p-grey">
                            {t("modals.signup.name2")}
                        </p>
                        <p className="ocean-p ocrean-p-700">{name}</p>
                    </div>
                    <ChangeBtn onHandleClick={() => setShowEdit(true)} />
                </div>
            ) : (
                <div
                    className={`account-personal-edit ${
                        windowWidth >= 992
                            ? "flex-between-row"
                            : "flex-center-col"
                    }`}
                >
                    <div className="label-input-div sign-up-form-field">
                        <label className="custom-modal-label">
                            {t("modals.signup.name2")}
                        </label>
                        <input
                            type="text"
                            value={name}
                            onChange={handleChange}
                            className="custom-modal-input"
                            placeholder={t("modals.signup.name")}
                        />
                    </div>
                    <SaveBtn onHandleClick={() => setShowEdit(false)} />
                </div>
            )}
        </div>
    );
};

export default Name;
